import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { defaultInfoBarContext, InfoBar, InfoBarContext } from "../common/info";
import { defaultMessageContext, Message, MessageContext } from "../common/message";
import RedirectToLogin from "../common/security/RedirectToLogin";
import { UserContext } from "../common/user/UserContext";
import { ThemeContext, themes } from "../common/theme/ThemeContext";
import "./App.scss";
import { useHistory, useLocation } from "react-router";
import Page from "./Page";
import Footer from "./footer/Footer";
import Header from "./header/Header";

function App() {
  const user = useContext(UserContext);
  const { t } = useTranslation();
  const [theme, setTheme] = useState(themes.green);

  const history = useHistory();
  const location = useLocation();
  const url = location.pathname + location.search + location.hash;

  useEffect(() => {
    setTheme(!(user.theme === "G") ? themes.blue : themes.green);
  }, [user]);

  const [infoBarContext, setInfoBarContext] = useState(
    Object.assign(defaultInfoBarContext, {
      toggle: (title, contentComponent) => {
        infoBarContext.isOpen = !infoBarContext.isOpen;
        infoBarContext.title = title;
        infoBarContext.contentComponent = contentComponent;

        setInfoBarContext(Object.create(infoBarContext));
      },
    })
  );

  useEffect(() => {
    return history.listen(() => {
      if (infoBarContext.isOpen) {
        infoBarContext.toggle();
      }
    });
  }, [url, history, location, infoBarContext.isOpen]);

  const [messageContext, setMessageContext] = useState(
    Object.assign(defaultMessageContext, {
      toggle: ({
        title = defaultMessageContext.title,
        content = defaultMessageContext.content,
        onYes = (e) => e.preventDefault(),
        onNo = (e) => e.preventDefault(),
        yesLabel = t("modalMessage.yesLabel"),
        noLabel = t("modalMessage.noLabel"),
        hideYes = false,
        hideNo = false,
        hideX = false,
        isWait = false,
      }) => {
        messageContext.show = !messageContext.show;
        messageContext.title = title;
        messageContext.content = content;
        messageContext.onYes = onYes;
        messageContext.onNo = onNo;
        messageContext.yesLabel = yesLabel;
        messageContext.noLabel = noLabel;
        messageContext.hideYes = hideYes;
        messageContext.hideNo = hideNo;
        messageContext.hideX = hideX;
        messageContext.isWait = isWait;

        setMessageContext(Object.create(messageContext));
      },
    })
  );

  useEffect(() => {
    document.title = t("application.title");
  }, [t]);

  return !user.isLoggedIn ? (
    // Use redirectTo received from login endpoint when user is logged in
    // but if login fails fallback to env variable value
    <RedirectToLogin url={user.redirectTo || process.env.REACT_APP_EPOSTA_LOGIN_URL} />
  ) : (
    <ThemeContext.Provider value={theme}>
      <MessageContext.Provider value={messageContext}>
        <InfoBarContext.Provider value={infoBarContext}>
          <section className="hero is-fullheight" style={{ fontFamily: theme.fontFamily }}>
            <Message
              show={messageContext.show}
              title={messageContext.title}
              content={messageContext.content}
              yesLabel={messageContext.yesLabel}
              onYes={messageContext.onYes}
              noLabel={messageContext.noLabel}
              onNo={messageContext.onNo}
              hideYes={messageContext.hideYes}
              hideNo={messageContext.hideNo}
              hideX={messageContext.hideX}
              isWait={messageContext.isWait}
            />
            <InfoBar
              contentComponent={infoBarContext.contentComponent}
              title={infoBarContext.title}
              isOpen={infoBarContext.isOpen}
            />
            <Header user={user} />
            <Page user={user} />
            <Footer />
          </section>
        </InfoBarContext.Provider>
      </MessageContext.Provider>
    </ThemeContext.Provider>
  );
}

export default App;
